export default {
  login: {
    title: 'Willkommen zur Online Support Anfrage (OSA)',
    subTitle: '  Geben Sie bitte Ihre Anmeldungs-Daten ein und klicken Sie danach auf die Schaltfläche [Anmelden]:',
    error: {
      failedUserPass: {
        header: 'Fehler bei der Anmeldung',
        message: 'Login-Name und/oder Passwort sind falsch. Bitte überpüfen Sie Ihre Eingaben und versuchen es anschließend erneut...',
      },
      osaIdMissing: {
        header: 'Fehler bei der Anmeldung',
        message: "Sie müssen sich registrieren, bevor Sie sich mit Ihren Login-Daten anmelden können. Starten Sie die Registrierung von Ihrem WERBAS//KSR Produkt aus überden Menu-Eintrag 'Supporttanfrage' des Hilfe-Menüs (?-Menü)",
      },
      cloudServiceException: 'Cloud service error',
      invalidUsername: {
        header: 'Fehler bei der Anmeldung',
        message: 'Login-Name und/oder Passwort sind falsch. Bitte überpüfen Sie Ihre Eingaben und versuchen es anschließend erneut...',
      },
    },
  },
  welcome: {
    header: 'Willkommen zum OSA-System der Werbas KSR GmbH',
    subHeader: 'Mit einem Klick auf eines der nachfolgenden Symbole gelangen Sie in den entsprechenden Bereich.',
    listTitle: 'Neue Support-Anfrage stellen',
    listSubtitle: 'Verwenden Sie diese Funktion, um eine neue Support-Anfrage zu stellen',
    menu: {
      newSupport: {
        title: 'Neue Support-Anfrage stellen',
        subtitle: 'Verwenden Sie diese Funktion, um eine neue Support-Anfrage zu stellen',
      },
      edit: {
        title: 'Anschrift und Kontakt-Daten',
        subtitle: 'In diesem Bereich können Sie die bei uns hinterlegten Anschrift- und Kontakt-Daten einsehen und ggf. korrigieren',
      },
      openCase: {
        title: 'Offene Support-Anfragen',
        subtitle: 'Sehen Sie in diesem Bereich Ihre offenen Support-Anfragen und deren aktuellen Status ein.',
      },
      closeCase: {
        title: 'Abgeschlossene Support-Anfragen',
        subtitle: 'In diesem Bereich können Sie die Support-Anfragen einsehen, die in den letzten 65 Tagen abgeschlossen wurden. ',
      },
    },
  },
  termsOfUse: {
    titleTermsOfUse: 'Nutzungsbestimmungen',
    titleShare: 'Aktuelle Kontingente des laufenden Monats',
    textCheckBox: 'Ja, ich bin mit den obigen Bestimmungen einverstanden.',
  },
  registration: {
    index: {
      title: 'Registrierung/Kunden-Information',
      error: {
        nameOrCompany: 'Der Name bzw. die Firma muss angegeben werden.',
        phoneBusiness: 'Geben Sie bitte Ihre Telefon-Nummber an.',
        email: 'Geben Sie bitte eine Email-Adresse an.',
      },
    },
    sentPage: {
      header: 'Registrierung abgeschlossen',
      body: 'Vielen Dank für Ihre Registrieung. Sie erhalten eine Email, sobald Ihr Zugang freigeschalten worden ist. Dann können Sie Anfragen über das OSA-System stellen sowie Ihre Support-Zeiten einsehen.',
      preFooter: 'Mit freundlichen Grüßen',
      footer: 'Ihre Werbas KSR GmbH',
    },
  },
  newSupportRequest: {
    dialog: {
      header: 'Support-Anfrage erhalten',
      body: 'Wir haben Ihre Support-Anfrage erhalten und werden diese schnellstmöglich bearbeiten',
      preFooter: 'Vielen Dank',
          footer: 'Ihre Werbas KSR GmbH',
    },
  },
  selectCustomer: {
      notSupportRequest: 'Der Kunde darf keine Support-Anfrage stellen. Der Kunde kann sich an den Vertrieb der Werbas KSR GmbH unter vertrieb@werbas-ksr.com oder +49 731 20555-165 wenden, wenn er künftig Support-Anfragen stellen können möchte.',
  },
  formRules: {
    required: 'Pflichtfeld',
    failEmail: '{item} ist keine gültige eMail',
    onlyNumbers: ' {item} ist keine gültige Telefonnummer',
    failWebSite: ' {item} ist keine gültige web',
    maxLength: 'Das Feld darf maximal {item} Zeichen enthalten',
    minLength: 'Das Feld muss mindestens {item} Zeichen enthalten',
  },
  global: {
    error: {
      NotAuthorized: {
        header: 'Fehler bei der Anmeldung',
        message: 'Sie müssen sich zuerst registrieren, bevor Sie sich mit Ihren Login-Daten anmelden können. Dies geschieht automatisch bei der Einrichtung des SMC. Sorgen Sie deshalb dafür, dass SMC von unseren Technikern bei Ihnen eingerichtet wird. ',
      },
      unerwarteter: {
        header: 'Fehler',
        message: 'Unerwarteter Fehler',
      },
      notLogged: {
        header: 'Sitzung abgelaufen',
        message: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      },
    },
  },
};
